import PriceMixin from "@/view/mixins/PriceMixin";

export default {
  mixins: [PriceMixin],
  computed: {
    vonqPrice() {
      return this.priceByType("vonq_price");
    },
    ratecardPrice() {
      return this.priceByType("ratecard_price");
    },
    totalVonqPriceAmount() {
      return this.products.reduce(
        (sum, item) =>
          sum +
          this.findPriceOrDefault(item, "vonq_price", this.currency.code)
            .amount,
        0
      );
    },
    totalVonqPriceAmountUSD() {
      return this.products.reduce(
        (sum, item) =>
          sum + this.findPriceOrDefault(item, "vonq_price", "USD").amount,
        0
      );
    }
  },
  methods: {
    totalVonqPriceAmountForCurrency(currency) {
      return this.products.reduce(
        (sum, item) =>
          sum + this.findPriceOrDefault(item, "vonq_price", currency).amount,
        0
      );
    }
  }
};
